import {
    Breadcrumb,
    Button,
    Cascader,
    DatePicker,
    Form,
    Input,
    InputNumber,
    notification,
    Radio,
    Select,
    Switch,
    TreeSelect,
    Upload,
    ConfigProvider
} from 'antd';

import { InboxOutlined, UploadOutlined } from '@ant-design/icons';


import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/locale/zh_CN';



import React, { useState } from 'react';
import movieAPI from "apis/movieAPI";
import useRequest from "hooks/useRequest";
import { Controller, useForm } from "react-hook-form";

import { Content, Footer } from 'antd/lib/layout/layout';

// const AddMovie2 = () => {

//     const [imgPreview, setImgPreview] = useState("");


//     const dayjs = require('dayjs')
//     //import dayjs from 'dayjs' // ES 2015
//     const [componentSize, setComponentSize] = useState('default');

//     const onFormLayoutChange = ({ size }) => {
//         setComponentSize(size);
//     };


//     // const onFinish = (fieldsValue) => {
//     //     console.log(fieldsValue)


//     // }


//     const { register, handleSubmit, setValue, control, trigger,reset } = useForm({
//         defaultValues: {
//             tenPhim: '',
//             biDanh: "",
//             moTa: '',
//             trailer: "",
//             hinhAnh: "",
//             ngayKhoiChieu: "",
//         },
//         mode: "onTouched",
//     })



//     const { data: handleAddMovie } = useRequest(
//         (values) => movieAPI.addMovie(values), { isManual: true }
//     );

//     const onSubmit = async (value) => {
//         try {

//             await handleAddMovie(value);

//             notification.success({
//                 message: 'Them phim thanh cong',

//             })
//             reset({
//                 tenPhim: '',
//                 biDanh: "",
//                 moTa: '',
//                 trailer: "",
//                 hinhAnh: "",
//                 ngayKhoiChieu: "",
//             })
//         } catch (error) {
//             notification.error({
//                 message: "them phim that bai",
//                 description: error,
//             })

//         }
//     }


//     const onChange: DatePickerProps['onChange'] = (date, dateString) => {
//         console.log(date, dateString);
//     };
//     const [date, setDate] = useState(new Date().toLocaleDateString('fr-FR'));

//     const config = [{ rules: { required: { value: true, message: "dame" } } }]

//     const [form] = Form.useForm()

//     const handleChangeImage = (evt) => {
//         // Đối với input type là file, có sẽ không dùng event.target.value mà thay thể bằng event.target.files
//         const file = evt.target.files[0];

//         if (!file) return;

//         // Lưu file vào field hinhAnh của hook form
//         setValue("hinhAnh", file);

//         // Xử lý hiển thị hình ảnh ra giao diện
//         const fileReader = new FileReader();
//         fileReader.readAsDataURL(file); // bất đồng bộ
//         fileReader.onload = (evt) => {
//             // Đọc file thành công
//             // evt.target.result: string base64
//             setImgPreview(evt.target.result);
//         };
//     };

//     const onReset = () => {
//         form.resetFields();
//     };


//     return (
//         <>

//             <Content style={{ margin: '0 16px' }}>
//                 <Breadcrumb style={{ margin: '16px 0' }}>

//                 </Breadcrumb>
//                 <h1>Thêm phim</h1>
//                 {/* <form onSubmit={handleSubmit(onSubmit)}>
//                     <div class="form-group">
//                         <div className='d-flex w-75 align-items-center'>
//                             <label for="tenPhim" style={{ width: '7em', fontSize: '18px' }}>Tên phim:</label>
//                             <input type="text" className="form-control " id="tenPhim" placeholder="name@example.com" {...register("tenPhim")} />
//                         </div>
//                     </div>
//                     <div class="form-group">
//                         <div className='d-flex w-75 align-items-center'>
//                             <label for="trailer" style={{ width: '7em', fontSize: '18px' }}>Trailer:</label>
//                             <input type="text" className="form-control " id="trailer" placeholder="name@example.com" {...register("trailer")} />
//                         </div>
//                     </div>
//                     <div class="form-group">
//                         <div className='d-flex w-75 align-items-center'>
//                             <label for="moTa" style={{ width: '7em', fontSize: '18px' }}>Tên phim:</label>
//                             <input type="text" className="form-control " id="moTa" placeholder="name@example.com"  {...register("moTa")} />
//                         </div>
//                     </div> */}


//                 <Form
//                     form={form}
//                     name="register"
//                     onFinish={handleSubmit(onSubmit)}
//                     labelCol={{ span: 2 }}
//                     wrapperCol={{ span: 16 }}
//                 >

//                     <Controller
//                         name="tenPhim"
//                         control={control}
//                         rules={{
//                             required: {
//                                 value: true,
//                                 message: "Tên phim không được để trống",
//                             },
//                         }}
//                         render={({ field, fieldState: { error } }) => (
//                             <Form.Item
//                                 label="Tên phim"
//                                 validateStatus={error ? "error" : ""}
//                                 help={error?.message}
//                             >
//                                 <Input type="text" {...field} />
//                             </Form.Item>
//                         )}
//                     />

//                     <Controller
//                         name="biDanh"
//                         control={control}
//                         rules={{
//                             required: {
//                                 value: true,
//                                 message: "Bí danh không được để trống",
//                             },
//                         }}
//                         render={({ field, fieldState: { error } }) => (
//                             <Form.Item
//                                 label="Bí danh"
//                                 validateStatus={error ? "error" : ""}
//                                 help={error?.message}
//                             >
//                                 <Input type="text" {...field} />
//                             </Form.Item>
//                         )}
//                     />

//                     <Controller
//                         name="moTa"
//                         control={control}
//                         rules={{
//                             required: {
//                                 value: true,
//                                 message: "Mô tả không được để trống",
//                             },
//                         }}
//                         render={({ field, fieldState: { error } }) => (
//                             <Form.Item
//                                 label="Mô tả"
//                                 validateStatus={error ? "error" : ""}
//                                 help={error?.message}
//                             >
//                                 <Input type="text" {...field} />
//                             </Form.Item>
//                         )}
//                     />



//                     <Controller
//                         name="trailer"
//                         control={control}
//                         rules={{
//                             required: {
//                                 value: true,
//                                 message: "Trailer không được để trống",
//                             },
//                         }}
//                         render={({ field, fieldState: { error } }) => (
//                             <Form.Item
//                                 label="Trailer"
//                                 validateStatus={error ? "error" : ""}
//                                 help={error?.message}
//                             >
//                                 <Input type="text" {...field} />
//                             </Form.Item>
//                         )}
//                     />



//                     <Controller
//                         name='hinhAnh'
//                         control={control}


//                         render={({ field }) => (
//                             <Form.Item
//                                 label='Hình Ảnh '
//                                 name='hinhAnh'



//                             >
//                                 <div>
//                                     {/* <input type="file" placeholder="Hình Ảnh" {...register("hinhAnh")} /> */}
//                                     <input
//                                         type="file"
//                                         placeholder="Hình Ảnh"
//                                         onChange={handleChangeImage}
//                                     />
//                                 </div>
//                                 {imgPreview && <img src={imgPreview} alt="preview" />}


//                             </Form.Item>
//                         )}

//                     />

//                     <Controller
//                         name='ngayKhoiChieu'
//                         control={control}
//                         rules={{ required: { value: true, message: 'Ngày khởi chiếu không được để trống' } }}

//                         render={({ field, fieldState: { error } }) => (
//                             <Form.Item
//                                 label='Ngày khởi chiếu '

//                                 validateStatus={error ? "error" : ""}
//                                 help={error?.message}

//                             >
//                                 <DatePicker

//                                     format={"DD/MM/YYYY"}
//                                     placeholderText="Select date"
//                                     onChange={(e) => {
//                                         const d = new Date(e).toLocaleDateString('fr-FR');
//                                         field.onChange(d);
//                                     }}
//                                     selected={field.value}
//                                 />
//                             </Form.Item>
//                         )}

//                     />











//                     <Form.Item>
//                         <Button type='primary'
//                             htmlType='submit'
//                             onClick={() => trigger()}
//                         >
//                             Thêm Phim
//                         </Button>
//                     </Form.Item>



//                     <Form.Item>

//                         <Button htmlType='reset'>x</Button>
//                     </Form.Item>








//                 </Form>

//                 {/* </form> */}
//             </Content>
//             <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
//         </>
//     );
// };






const AddMovie2 = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => console.log(data);
    console.log(errors);

    return (
        <Form>
            <form onSubmit={handleSubmit(onSubmit)}>
                <input type="text" placeholder="Tên phim" {...register("Tên phim", { required: true })} />
                <input type="text" placeholder="Bí danh" {...register("Bí danh", { required: true })} />
                <input type="text" placeholder="Mô tả" {...register("Mô tả", { required: true })} />
                <input type="text" placeholder="Trailer" {...register("Trailer", {})} />
                <input type="url" placeholder="Hình ảnh" {...register("Hình ảnh", {})} />
                <input type="datetime" placeholder="Ngày khởi chiếu" {...register("Ngày khởi chiếu", {})} />

                <input type="submit" />
            </form>
        </Form>
    );
}
export default AddMovie2;